import * as React from "react"
import {Button, Header, Modal} from "semantic-ui-react"

export enum InfoModalButton {
  OK,
  Close,
}

export interface InfoModalProps {
  heading: string
  message: string
  button: InfoModalButton | null
  onDismiss: () => void
}

export function InfoModal(props: InfoModalProps) {
  const {heading, message, button, onDismiss} = props

  function makeButton(button: InfoModalButton) {
    switch (button) {
      case InfoModalButton.Close:
        return <Button onClick={onDismiss}>Close</Button>
      case InfoModalButton.OK:
        return (
          <Button positive onClick={onDismiss}>
            OK
          </Button>
        )
    }
  }

  return (
    <Modal
      dimmer="blurring"
      size="small"
      open={true}
      onClose={onDismiss}
      closeOnDimmerClick={false}
    >
      <Header content={heading} />
      <Modal.Content>
        <p>{message}</p>
      </Modal.Content>
      {button != null && <Modal.Actions>{makeButton(button)}</Modal.Actions>}
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/components/InfoModal.tsx